export type ClientSkinId='classic'|'warm'|'mono'|'sage'|'wine'
export const clientSkinColors:Record<ClientSkinId,string[]>={
  classic:['#1890FF','#00318C','#F3F7FC','#E4F1FF','#FFFFFF'],
  warm:['#9A662F','#493524','#F7F3EB','#F2E7D6','#FFFDF8'],
  mono:['#25272B','#202226','#F4F4F3','#E7E7E5','#FFFFFF'],
  sage:['#637B68','#344A3B','#F3F5EF','#E2E9DB','#FEFFF9'],
  wine:['#783A49','#4B2932','#F8F2F1','#EDDEE0','#FFFCFA']
}
// 只在当前域名的机构资料完成校验后应用，不使用登录客户或旧缓存决定店铺。
export function resolveClientSkin(orgId:number,org:any,ready:boolean){
  let settings:any={}
  if(ready && Number.isSafeInteger(orgId) && orgId>=1000 && Number(org?.id)===orgId){
    try{settings=typeof org.settings==='string'?JSON.parse(org.settings):org.settings}catch{/* 缺省经典 */}
  }
  const id:ClientSkinId=settings && Object.prototype.hasOwnProperty.call(clientSkinColors,settings.miniappTheme)?settings.miniappTheme:'classic'
  return {id,colors:clientSkinColors[id],follow:settings?.homeImageFollowSkin===true}
}
export function applyClientSkin(skin:ReturnType<typeof resolveClientSkin>,root=document.documentElement){
  root.dataset.clientSkin=skin.id
  root.style.setProperty('--antd-wave-shadow-color',skin.colors[0])
  root.style.setProperty('--clientPrimary',skin.colors[0])
  root.style.setProperty('--clientPrimaryRgb',[1,3,5].map(offset=>parseInt(skin.colors[0].slice(offset,offset+2),16)).join(','))
  root.dataset.homeImageFollow=String(skin.follow)
  const names=['--activeColor','--clientHead','--clientCanvas','--clientSoft','--clientSurface']
  names.forEach((name,index)=>root.style.setProperty(name,skin.colors[index]))
  root.style.setProperty('--clientGradientEnd',skin.id==='classic'?'':skin.colors[1])
}
